import React from "react";
import Link from "theme/components/atoms/Typography/Link";
import { useLocation } from "react-router";
import { useMemo } from "react";

const getCategoryFacet = (category) => {
  return category?.layer?.dynamicFacets.find(
    ({ __typename }) => __typename === "CategoryFacet"
  );
};

const hasFacetNavigation = (category) => {
  const categoryFacet = getCategoryFacet(category);
  return categoryFacet && categoryFacet.buckets.length > 0;
};

export const hasCategoryNavigation = (category) => {
  return hasFacetNavigation(category) || category.children?.length > 0;
};

const useSearch = () => {
  const location = useLocation();
  return useMemo(() => {
    const params = new URLSearchParams(location.search);
    // When select a navigation category, we
    // always want to start from the first page,
    // so we remove it from the search params.
    params.delete("page");
    return params.toString();
  }, [location.search]);
};

const CategoryNavigation = ({ category }) => {
  const search = useSearch();

  const categoryFacet = getCategoryFacet(category);
  const children = hasFacetNavigation(category)
    ? categoryFacet.buckets
        .map(({ path, docCount, label }) => ({
          path,
          docCount,
          label,
        }))
        .filter(({ docCount }) => docCount !== 0)
    : category.children.map(({ path, name }) => ({
        path,
        label: name,
        docCount: null,
      }));

  return (
    <div className="category-navigation">
      <ul className="category-navigation__list">
        {children.map((child) => (
          <li key={child.path} className="category-navigation__element">
            <Link
              to={{
                pathname: child.path,
                search: search,
              }}
            >
              {child.label}{" "}
              {child.docCount !== null ? <>({child.docCount})</> : null}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CategoryNavigation;
